'use client';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Container, Typography } from '@mui/material';
export const Section = ({ header, headerVariant = 'h2', children, fluid = false, containerProps = {}, disableGutters = false, sx = {} }) => {
    const fullWidth = fluid ? false : 'lg';
    return (_jsx(Box, { component: "section", sx: { width: '100%', ...sx.root }, children: _jsx(Box, { sx: { ...styles.overlay, ...sx.overlay }, children: _jsxs(Container, { maxWidth: fullWidth, sx: sx.container, disableGutters: disableGutters, ...containerProps, children: [header && (_jsx(Typography, { variant: headerVariant, sx: sx.header, children: header })), _jsx(Box, { sx: { ...styles.content, ...sx.content }, children: _jsx(_Fragment, { children: children }) })] }) }) }));
};
const styles = {
    overlay: {
        height: '100%'
    },
    content: {
        width: '100%',
        display: 'flex'
    }
};
